module.exports = __webpack_public_path__ + "static/media/frontlogo.483e6215.png";